<template>
  <div id="app">
    <!-- <router-view/> -->
    <!-- <keep-alive>
      <router-view v-show="$route.meta.keepAlive" />
    </keep-alive> -->
    <router-view v-if="isRouterAlive" />
  </div>
</template>

<script>
export default {
  name: "App",
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isRouterAlive: true,
    };
  },
  created: function () {
    // if (document.body.clientWidth > 750) {
    //   let goToUrl = 'https://pc.dmex.finance/#'
    //   var url = window.location.href;
    //   try {
    //     if (url && url.indexOf('/Invite/') > 1) {
    //       window.location.href = goToUrl+url.substring(url.indexOf('/Invite/'));
    //     } else {
    //       window.location.href = goToUrl;
    //     }
    //   } catch (e) {
    //     window.location.href = goToUrl;
    //   }
    // }
  },
  mounted() {
    if (document.body.clientWidth * 0.04 > 24) {
      document.documentElement.style.fontSize = 24 + "px";
    } else {
      document.documentElement.style.fontSize =
        document.body.clientWidth * 0.04 + "px";
    }
    window.onresize = () => {
      return (() => {
        if (document.body.clientWidth * 0.04 > 24) {
          document.documentElement.style.fontSize = 24 + "px";
        } else {
          document.documentElement.style.fontSize =
            document.body.clientWidth * 0.04 + "px";
        }
      })();
    };
  },
  methods: {
  reload(){
      this.isRouterActive = false;
      this.$nextTick(function(){
        this.isRouterActive = true;
      })
    }
  },
};
</script>

<style>
#app {
  margin: 0 auto;
  font-family: sans-serif;
}


::-webkit-scrollbar {
    width: 0px;
    height: 0px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue